import { useEffect, useState } from "react";

/**
 * useClient
 * Hook to determine if the component is mounted on the client side.
 * Returns a boolean indicating client-side rendering.
 */
const useClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};

export default useClient;
